module.exports = __webpack_public_path__ + "img/rad-conv-Sala-Control-XD-2.60b1343e.png";